import { send } from "../../send";

/**
 * send(1.method, 2.url, 3.data, 4.expend) 1.请求类型 2.请求地址 3.请求参数 4.拓展(如统一的uuid)
 * 平台模块
 */

export const Park = {
    // 企业接入状态
    getCompanyTotal(parmas, expend) { // 查询企业接入总个数
        return send("GET", "/api/park/company/total/count", parmas, expend);
    },
    getNormalCompanyTotal(parmas, expend) { // 查询正常企业个数
        return send("GET", "/api/park/company/normal/count", parmas, expend);
    },
    getWarnCompanyTotal(parmas, expend) { // 查询告警企业个数
        return send("GET", "/api/park/company/warn/count", parmas, expend);
    },
    getCompanyTotalList(parmas, expend) { // 查询个数分析列表
        return send("GET", "/api/park/company/statistics", parmas, expend);
    },
    // 告警及预警数查询
    getWarnTotal(parmas, expend) { // 企业获取告警次数
        return send("GET", "/api/park/device/warnTime/statistics", parmas, expend);
    },
    // 接入套数
    getSiteCount(parmas, expend) { // 企业接入的总套数
        return send("GET", "/api/park/site/access/total/count", parmas, expend);
    },
    // 设备完好率
    getDeviceIntact(parmas, expend) { // 企业设备完好率
        return send("GET", "/api/park/siteDevice/device/intact/rate", parmas, expend);
    },
    // 设备完好率
    getDeviceIntact_admin(parmas, expend) { // 企业设备完好率管理页面
        return send("GET", "/api/park/siteDevice/device/intact/rate2", parmas, expend);
    },
    // 接入套数 不同状态
    getAccessWarnCount(parmas, expend) { // 企业告警套数
        return send("GET", "/api/park/site/statistics", parmas, expend);
    },
    getAccessEarlyWarnCount(parmas, expend) { // 企业预警套数
        return send("GET", "/api/park/company/earlyWarn/total/count", parmas, expend);
    },
    // 企业下设备告警及预警次数
    getCompanyAllWarnCount(parmas, expend) {
        return send("GET", "/api/park/device/warnTime/statistics/count", parmas, expend);
    },
    // 获取所有企业站点数 设备数 rtu数
    getAllCount(parmas, expend) {
        return send("GET", "/api/park/company/find/info/statistics", parmas, expend);
    },
    // 获取告警或预警详情
    getWarnOrEasyDeils(parmas, expend) {
        return send("GET", "/api/park/site/statistics/detail", parmas, expend);
    },
    // 查询企业分组列表
    getGroupEnum(parmas, expend) {
        return send("GET", "/api/park/enum/find/Group", parmas, expend);
    },
    // 查询企业所属行业列表
    getIndustriesEnum(parmas, expend) {
        return send("GET", "/api/park/enum/find/Industries", parmas, expend);
    },
    // 查询废气废水等数据
    getRTUAllData(parmas, expend) {
        return send("GET", "/api/park/rtu/screen", parmas, expend);
    },
    // 查询环境气象
    getWeather(parmas, expend){
        return send("GET", "/api/park/qxlog/query", parmas, expend);
    }
    // http://huayi.wodiantech.com/api/park/qxlog/query?content=%7B%22uuids%22:%2200a00795-ef81-4e2c-895c-0bdce88d2e52%22%7D&
}